import BackButtonMobile from './BackButtonMobile'
import BackButtonDesktop from './BackButtonDesktop'

function BackButton({ isMobile }: { isMobile: boolean }) {
  return !isMobile ? <BackButtonMobile /> : <BackButtonDesktop />
}

export default BackButton
